<script>
  // Exponents
  import Matrix from '@/Exponents/Matrix.svelte';
  import Eidos from '@/Exponents/Eidos.svelte';
  import Hub from '@/Exponents/Hub.svelte';

  // Integrants
  import { Router, Route, NotFound, redirect } from '@/Integrants/Router/Index.js';

  export let matrix;
  export let eidos;
  export let hub;
  
  // let showModal = true;

  const guard = (ctx, nxt) => {
    if (true) {
      redirect('/login');
    } else {
      next();
    }
  };

</script>

<main>
  <Matrix>
    <Router>
      <Route path="/" component="{Eidos}" {matrix} {eidos}></Route>
      <Route path="/powerwall" component="{Hub}" {matrix} {hub}></Route>
    </Router>
  </Matrix>
</main>